<template>
 <div >
   <div class="detailsTitle">
      <h4>平账记录</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="操作类型:" prop="operationType" >
                <el-select  v-model="searchFrom.operationType"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="增项" value="0"></el-option>
                  <el-option label="减项" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="平账费目:" prop="operationName">
                <el-select  v-model="searchFrom.operationName"   placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="提现手续费" value="1"></el-option>
                   <el-option label="银行利息" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="操作时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="operationType" label="操作类型" width="120">
          <template scope="scope">{{[ "增项", "减项"][scope.row.operationType]}}</template>
        </el-table-column>
        <el-table-column property="operationName" label="平账费目" width="120">
          <template scope="scope">{{[ "提现手续费", "银行利息"][scope.row.operationName-1]}}</template>
        </el-table-column>
        <el-table-column property="accountName" width="270"  :formatter="emptyFn"   label="平台账户名称"></el-table-column>
         <el-table-column property="lastBalanceMoney" width="150"  :formatter="emptyFn"   label="平账前金额(元)"></el-table-column>
         <el-table-column property="balanceMoney" width="150"  :formatter="emptyFn"   label="平账金额(元)"></el-table-column>
         <el-table-column property="accountMoney" width="150"  :formatter="emptyFn"   label="平账后金额(元)"></el-table-column>
        <el-table-column property="reason"  width="260"  :formatter="emptyFn"   label="平账原因"></el-table-column>
        <el-table-column property="createUserName"  width="200"  :formatter="emptyFn"   label="操作人"></el-table-column>
        <el-table-column property="createTime"  width="170"  :formatter="dateTimeFormat"   label="操作时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>

</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  tBalanceAccounLIst // 列表
} from '@/api/consignment'
export default {
  data () {
    let id = this.$route.query.id
    let type = this.$route.query.type
    return {
      id: id,
      type: type,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        accountId: id,
        extertransTypes: [1, 2, 3, 4, 5]
      },
      tableList: [],
      loading: 'false',
      total: 0,
      isDisable: false

    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 132) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/tExternalTransdetai/exportList',
        form,
        '交易明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tBalanceAccounLIst(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null,
        accountId: this.id,
        extertransTypes: [1, 2, 3, 4, 5]
      }
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
